import moment from 'moment';
import { CONTRATO_ENTE_PRIVADO_ACAO_AVALIA_COOP } from '../../library/ContratoEntePrivadoAcaoAvalia';
import { CONTRATO_STATUS_EM_EDICAO } from '../../library/ContratoStatus';
import {
  CONTRATO_TIPO_ENTE_PRIVADO,
  CONTRATO_TIPO_ENTE_PRIVADO_NAME,
} from '../../library/ContratoTipos';
import { CONTRATO_VERSAO_CONTRATO } from '../../library/ContratoVersoes';
import {
  fixAllAtividadesIndex,
  fixAllPlanosTrabalhoIndex,
} from '../../utils/ContratoEntePrivadoUtils';
import { getHistoricoArrayNormalized } from '../../utils/ContratoUtils';
import { transformNullIntoEmpty } from '../../utils/DataUtils';
import {
  LOADED_CONTRATO_ANALISE_OPERACIONAL,
  LOADING_CONTRATO_ANALISE_OPERACIONAL,
} from './ContratosActions';
import {
  CADASTRO_CONTRATO_ENTE_PRIVADO_ACTION,
  CHANGED_CONTRATO_ENTE_PRIVADO_EDITING_VALUE_ACTION,
  CLEARED_CONTRATO_ENTE_PRIVADO_ACTION,
  EDITAR_CONTRATO_ENTE_PRIVADO_ACTION,
  LOADED_CONTRATO_ACTION,
  LOADED_CONTRATO_ENTE_PRIVADO_ARQUIVOS,
  LOADED_CONTRATO_ENTE_PRIVADO_HISTORICO_ANALISE_OPERACIONAL,
  LOADED_CONTRATO_VALIDACAO,
  LOADED_LINHAS_ORCAMENTARIAS,
  LOADING_CONTRATO_ACTION,
  LOADING_CONTRATO_ENTE_PRIVADO_ARQUIVOS,
  LOADING_CONTRATO_ENTE_PRIVADO_HISTORICO_ANALISE_OPERACIONAL,
  LOADING_CONTRATO_VALIDACAO,
  LOADING_LINHAS_ORCAMENTARIAS,
} from './ContratosEntePrivadoActions';

const CONTRATO_EDITING_NOT_NULL_PROPS = [
  'atividades',
  'codCoop',
  'cpfProfessor',
  'dataFim',
  'dataInicio',
  'emailCoop',
  'idEscola',
  'planosTrabalho',
  'totalMeses',
  'templateContrato',
];

const CONTRATO_EDITING_INITIAL_STATE = {
  codCoop: '',
  cpfProfessor: '',
  dataFim: '',
  dataInicio: '',
  emailCoop: '',
  idEscola: -1,
  nomEscola: '',
  totalMeses: 0,
  tipoContrato: CONTRATO_TIPO_ENTE_PRIVADO,
  versaoContrato: CONTRATO_VERSAO_CONTRATO,
  flgStatus: -1,
  ativo: true,
  arquivos: null,
  planoTrabalho: [],
  atividades: [],
  escolaCompromissoCheck: false,

  idAditivo: null,
  idDistrato: null,
  idContrato: null,

  loadingContrato: false,

  loadingHistoricoAnaliseOperacional: false,
  historicoAnaliseOperacional: [],

  ultimaAvaliaEnviado: {
    id: null,
    comentario: null,
    acaoAvalia: -1,
    acaoAvaliaValue: null,
    flgPrincipal: false,
    datAlteracao: null,
    extensaoArquivo: null,
    caminho: null,
  },

  avaliaAprovada: {
    id: null,
    comentario: null,
    acaoAvalia: -1,
    acaoAvaliaValue: null,
    flgPrincipal: false,
    datAlteracao: null,
    extensaoArquivo: null,
    caminho: null,
  },

  htmlContrato: '',
  templateContrato: '',
};

const INITIAL_STATE = {
  loadingArquivos: false,
  loadingAlteraArquivo: false,
  loadingAlteraStatus: false,
  // loadingHtmlContrato: false,
  loadingTemplateContrato: false,
  loadingHistoricoAnaliseOperacional: false,
  contratoEditing: CONTRATO_EDITING_INITIAL_STATE,

  loadingLinhasOrcamentarias: false,
  linhasOrcamentarias: [],
};

export default function ContratosEntePrivadoReducer(
  state = INITIAL_STATE,
  action
) {
  switch (action.type) {
    case CLEARED_CONTRATO_ENTE_PRIVADO_ACTION:
      return { ...state, contratoEditing: CONTRATO_EDITING_INITIAL_STATE };
    case CADASTRO_CONTRATO_ENTE_PRIVADO_ACTION:
      return {
        contratoEditing: transformNullIntoEmpty(
          {
            ...state.contratoEditing,
            dados: action.payload,
          },
          CONTRATO_EDITING_NOT_NULL_PROPS
        ),
      };
    case EDITAR_CONTRATO_ENTE_PRIVADO_ACTION:
      return {
        contratoEditing: transformNullIntoEmpty(
          {
            ...state.contratoEditing,
            dadosEdit: action.payload,
          },
          CONTRATO_EDITING_NOT_NULL_PROPS
        ),
      };
    case CHANGED_CONTRATO_ENTE_PRIVADO_EDITING_VALUE_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...state.contratoEditing,
          [action.payload.name]: action.payload.value,
        },
      };
    case LOADING_LINHAS_ORCAMENTARIAS:
      return { ...state, loadingLinhasOrcamentarias: action.payload };
    case LOADED_LINHAS_ORCAMENTARIAS:
      return {
        ...state,
        linhasOrcamentarias: action.payload,
      };
    case LOADING_CONTRATO_ACTION:
      return { ...state, loadingContrato: action.payload };
    case LOADED_CONTRATO_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...action.payload,
          planoTrabalho: fixAllPlanosTrabalhoIndex(
            action.payload.planosTrabalho || []
          ),
          atividades: fixAllAtividadesIndex(action.payload.atividades || []),
        },
      };
    case LOADING_CONTRATO_ENTE_PRIVADO_HISTORICO_ANALISE_OPERACIONAL:
      return { ...state, loadingHistoricoAnaliseOperacional: action.payload };
    case LOADED_CONTRATO_ENTE_PRIVADO_HISTORICO_ANALISE_OPERACIONAL: {
      let historico = getHistoricoArrayNormalized(
        action.payload.map((item) => {
          return {
            ...item,
            isAnaliseOperacional:
              item.acaoAvaliaValue === CONTRATO_ENTE_PRIVADO_ACAO_AVALIA_COOP
                ? false
                : item.isAnaliseOperacional,
            nome: item.nome || '',
            datAlteracao: moment(
              item.datAlteracao,
              'DD MM YYYY HH mm ss'
            ).format('YYYY MM DD HH:mm:ss'),
          };
        }),
        'datAlteracao',
        'id',
        'isAnaliseOperacional',
        'comentario',
        'nome'
      );
      if (
        historico &&
        historico.length === 1 &&
        historico[0].acaoAvaliaValue ===
          CONTRATO_ENTE_PRIVADO_ACAO_AVALIA_COOP &&
        state.contratoEditing.flgStatus === CONTRATO_STATUS_EM_EDICAO
      ) {
        historico = [];
      }
      return {
        ...state,
        contratoEditing: transformNullIntoEmpty(
          {
            ...state.contratoEditing,
            historicoAnaliseOperacional: historico,
          },
          CONTRATO_EDITING_NOT_NULL_PROPS
        ),
      };
    }
    case LOADING_CONTRATO_VALIDACAO:
      return { ...state, loadingHtmlContrato: action.payload };
    case LOADED_CONTRATO_VALIDACAO:
      return {
        ...state,
        contratoEditing: transformNullIntoEmpty(
          {
            ...state.contratoEditing,
            htmlContrato: action.payload,
          },
          CONTRATO_EDITING_NOT_NULL_PROPS
        ),
      };
    case LOADING_CONTRATO_ENTE_PRIVADO_ARQUIVOS:
      return { ...state, loadingArquivos: action.payload };
    case LOADED_CONTRATO_ENTE_PRIVADO_ARQUIVOS:
      return {
        ...state,
        contratoEditing: transformNullIntoEmpty(
          {
            ...state.contratoEditing,
            arquivos: action.payload,
          },
          CONTRATO_EDITING_NOT_NULL_PROPS
        ),
      };
    case LOADING_CONTRATO_ANALISE_OPERACIONAL:
      if (action.payload.tipoContrato === CONTRATO_TIPO_ENTE_PRIVADO_NAME) {
        return { ...state, loadingTemplateContrato: action.payload.loading };
      }
      return state;
    case LOADED_CONTRATO_ANALISE_OPERACIONAL:
      if (action.payload.tipoContrato === CONTRATO_TIPO_ENTE_PRIVADO_NAME) {
        return {
          ...state,
          contratoEditing: transformNullIntoEmpty(
            {
              ...state.contratoEditing,
              templateContrato: action.payload.template,
            },
            CONTRATO_EDITING_NOT_NULL_PROPS
          ),
        };
      }
      return state;
    default:
      return state;
  }
}
